/*jshint esversion: 9 */
/*jshint sub:true*/
import { mapGetters, mapActions} from 'vuex';
import TaktJournal from '@/components/ProjectTaktJournal/TaktJournal.component.vue';
import TaktJournalDay from '@/components/ProjectTaktJournal/TaktJournalDay.component.vue';
import TaktJournalDayCommentary from '@/components/ProjectTaktJournal/TaktJournalDayCommentary.component.vue';
import TaktJournalDayOverviewContent from '@/components/ProjectTaktJournal/TaktJournalDayOverviewContent.component.vue';
import TaktJournalDayContentEntry from '@/components/ProjectTaktJournal/TaktJournalDayContentEntry.component.vue';
import TaktJournalDayContentEntryRow from '@/components/ProjectTaktJournal/TaktJournalDayContentEntryRow.component.vue';


import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
import StandardFlexBox from '@/components/StandardComponents/StandardFlexBox.component.vue';


export const TaktJournalMixin = {
  components: {
    TaktJournal,
    TaktJournalDay,
    TaktJournalDayCommentary,
    TaktJournalDayOverviewContent,
    TaktJournalDayContentEntry,
    TaktJournalDayContentEntryRow,

    WorkPackage,
    StandardFlexBox,
  },
  data: () => ({
    selected_date: '',
    stati_today: [
      {
        icon: 'alarm_on',
        text: 'Ready',
        prop: 'wps_ready'
      },
      {
        icon: 'flight_takeoff',
        text: 'Started',
        prop: 'wps_started'
      },
      {
        icon: 'done',
        text: 'Done',
        prop: 'wps_done'
      },
      {
        icon: 'thumb_up',
        text: 'Checked',
        prop: 'wps_checked'
      },
      {
        icon: 'close',
        text: 'Closed',
        prop: 'wps_closed'
      },
      {
        icon: 'warning',
        text: 'Stopped',
        prop: 'wps_stop'
      }
    ],
    show_status: true,
    show_comments: true,
    show_steps: true,
    show_images: true,
    show_other_changes: true,
    show_contact_name: true,
    commentary: [],
    editCommentary: false
  }),
  computed: {
    ...mapGetters('Project', [
      'getProject',
    ]),
    ...mapGetters('ProjectTaktJournal', [
      'getTaktJournal',
      'getTaktJournalSettings',
      'getTaktJournalDatePickerEntries',
      'getTaktJournalDatePicker',
    ]),
    ...mapGetters('ProjectCalendar', [
      'getCalendar',
      'getWeekDays',
    ]),
  },
  methods: {
    ...mapActions('ProjectTaktJournal', [
      'setTaktJournalSettings',
      'setTaktJournalSettingsDatePicker',
      'requestTaktJournalLastWeek',
      'requestTaktJournalByDates'
    ]),
    scrollToDate(date) {
      document.getElementById(date).scrollIntoView({behavior: 'smooth'});
    },
    getStatusIcon(status) {
      switch (status) {
        case 'ready':
          return 'alarm_on';
        case 'started':
          return 'flight_takeoff';
        case 'done':
          return 'done';
        case 'checked':
          return 'thumb_up';
        case 'closed':
          return 'close';
        case 'stop':
          return 'warning';
      }
    },


    exportJournal() {
     // Get HTML to print from element
     const prtHtml = document.getElementById('takt-journal-content').innerHTML;
     const styleSheets = Array.from(document.styleSheets).filter(
       (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
     );


     let styles = {};
     for (let style of styleSheets) {
       if (style instanceof CSSStyleSheet && style.cssRules) {
         for (let rule of style.rules) {
           if (!styles[rule.selectorText]) {
             if (rule.cssText.startsWith('.v-application')) {
               styles[rule.selectorText] = rule.cssText.substring(15);
             } else {
               styles[rule.selectorText] = rule.cssText;
             }
           }
         }
       }
     }

     let stylesHtml = '';
     for (let css_class in styles) {
       stylesHtml += styles[css_class] + '\n';
     }

     const WinPrint = window.open('', 'TAKT.report', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=1,status=0');

     WinPrint.document.write(`<!DOCTYPE html>
     <html>
       <head>
         <style type="text/css">
           ${stylesHtml}

           @media print {
              body {
                margin: 0;
                background-color: white;
              }
             .takt-journal-day {
               zoom: calc(1/0.7);
               padding: 5mm;
               page-break-after: always;
             }
           }

           @page {
             margin: 5mm;
           }

         </style>
         <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">
         <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">
         <link href="https://fonts.googleapis.com/css?family=Material+Icons" rel="stylesheet">
       </head>
       <body>
         ${prtHtml}
       </body>
     </html>`);


     WinPrint.document.close();
     WinPrint.focus();
     setTimeout(function() {
       WinPrint.print();
       WinPrint.close();
     }, 1500);


 },

  setCalendar(event){
    if (!this.getTaktJournalSettings.select_range) {
        if (this.getTaktJournalSettings.date_picker.length > 0) {
          this.setTaktJournalSettings({date_picker: []})
        } else {
          this.requestTaktJournalByDates({project_id: this.project_id, dates: event,
            show_status: this.show_status, show_comments: this.show_comments, show_steps: this.show_steps,
            show_images: this.show_images, show_other_changes: this.show_other_changes
          });
        }
    } else {
      if (this.getTaktJournalSettings.select_range && this.getTaktJournalSettings.date_picker.length > 1) {
        this.setTaktJournalSettings({date_picker: []})
      } else {
        this.setTaktJournalSettingsDatePicker(event);
        this.requestTaktJournalByDates({project_id: this.project_id, dates: event,
          show_status: this.show_status, show_comments: this.show_comments, show_steps: this.show_steps,
          show_images: this.show_images, show_other_changes: this.show_other_changes
        });
      }
    }
  }
  }
};
